import { filter } from 'lodash'
import {
  VIEW_ADMIN, VIEW_AUDITOR, VIEW_CLIENT, TIPO_USUARIO,
} from 'utils/constantes'

export const getTipoUsuarios = (state) => state.tipoUsuarios.lista
export const getTipoUsuariosAuditor = (state) => filter(state.tipoUsuarios.lista, (tipo) => (
  VIEW_AUDITOR.includes(tipo.id)
))
// Gerente de Crédito é usuário interno LIFE (sem vínculo com empresa): cadastrado/listado
// na tela de Usuários LIFE, não na de usuários de empresa.
export const getTipoUsuariosAdmin = (state) => filter(state.tipoUsuarios.lista, (tipo) => (
  VIEW_ADMIN.includes(tipo.id)
  || tipo.id === TIPO_USUARIO.CLIENTE.GERENTE_CREDITO
  || tipo.id === TIPO_USUARIO.CLIENTE.OBSERVADOR_CREDITO
))
export const getTipoUsuariosCliente = (state) => filter(state.tipoUsuarios.lista, (tipo) => (
  VIEW_CLIENT.includes(tipo.id)
))
export const getIsCarregandoListaTipoUsuarios = (state) => state.tipoUsuarios.isCarregandoLista
